<res-base-modal [modalTitle]="modalTitle" [modalClass]="modalClass" [modalAutomationId]="modalAutomationId"
    [modalContainerAutomationId]="modalContainerAutomationId" [primaryButtonLabel]="'OK'"
    (primaryButtonActionEmt)="ok()" [isPrimaryBtnEnabled]="isPrimaryButtonEnabled()"
    (closeButtonActionEmt)="closeModal()" [secondaryButtonLabel]="'Cancel'"
    [titleText]="isPrimaryButtonEnabled()? '' : 'All fields are required. Please complete all fields to continue.'"
    [modalHelpIndex]="modalHelpIndex">

    <form #transformersContentForm="ngForm">
        <div *ngIf="getModalTypeByKeyName('number')" class="number-grid-container">
            <label>Operation:</label>
            <label>Convert File Size</label>
            <label for="cmbSize">From:</label>
            <select id="cmbSize" [(ngModel)]="selectedFileSize" name="fileSize" required
                [attr.data-automation-id]="modalAutomationId + '-from-option'">
                <option *ngFor="let unit of fileSizes | keys" [value]="unit">{{unit}}</option>
            </select>
            <label>To:</label>
            <label>Bytes</label>
        </div>
        <div *ngIf="getModalTypeByKeyName('text')" class="text-grid-container">
            <label>Operation:</label>
            <select [(ngModel)]="selectedTextOperation" name="textOperation" required
                [attr.data-automation-id]="modalAutomationId + '-operation-option'">
                <option *ngFor="let op of textOperations | values" [value]="op">{{op}}</option>
            </select>
            <div id="concatDiv" *ngIf="selectedTextOperation === 'Concatenate'" class="inner-grid-container">
                <label for="inputDelimiter">Delimiter:</label>
                <res-custom-combo-box [items]="concatDelimiters" [allItems]="concatDelimiters" [onSelectionChanged]="onDelimiterChanged"
                    [automationId]="modalAutomationId+'-concat-delimiter'" [selectedItem]="selectedDelimiter" [onInputFocusLost]="onFocusChanged"
                    inputWidth="60"></res-custom-combo-box>
            </div>
            <div id="replaceDiv" *ngIf="selectedTextOperation === 'Replace'" class="inner-grid-container">
                <label for="txtReplace">Replace:</label>
                <input id="txtReplace" [(ngModel)]="replaceField" name="replaceField" required
                    [attr.data-automation-id]="modalAutomationId + '-replace-field-input'">
                <label for="txtWith">With:</label>
                <input id="txtWith" [(ngModel)]="withField" name="withField" required
                    [attr.data-automation-id]="modalAutomationId + '-with-field-input'">
            </div>
            <div *ngIf="isSufixPrefixOperation()" class="inner-grid-container">
                <label>Characters:</label>
                <input [(ngModel)]="inputChars" name="inputChars" required
                    [attr.data-automation-id]="modalAutomationId + '-suffix-prefix-input'">
            </div>
            <div *ngIf="isTrimOperation()" class="inner-grid-container">
                <label># of Characters:</label>
                <input type="number" min="0" id="txtTrimChars" [(ngModel)]="trimChars" name="trimChars" required
                    [attr.data-automation-id]="modalAutomationId + '-trim-input'">
            </div>
        </div>

        <div *ngIf="getModalTypeByKeyName('date')">
            <div>
                <ul class="inline-select">
                    <li>
                        <label [ngClass]="{'active': !isDateTimeOneField}">
                            <input type="radio" [(ngModel)]="isDateTimeOneField" name=separatedFields [value]="false"
                                [attr.data-automation-id]="modalAutomationId + '-separate-fields-radio-button'" />
                            Date and Time in Separate Fields
                        </label>
                    </li>
                    <li>
                        <label [ngClass]="{'active': isDateTimeOneField}">
                            <input type="radio" [(ngModel)]="isDateTimeOneField" name=oneField [value]="true"
                                [attr.data-automation-id]="modalAutomationId + '-one-field-radio-button'" />
                            Date and Time in One Field
                        </label>
                    </li>
                </ul>
            </div>
            <div class="date-grid-container">
                <label for="inputDateFormat">Date Format:</label>
                <res-custom-combo-box [items]="dateFormats" [allItems]="dateFormats" [selectedItem]="selectedDateFormat"
                    [onSelectionChanged]="onSelectedDateChanged" [automationId]="modalAutomationId+'-date-format'" [onInputFocusLost]="onFocusChanged">
                </res-custom-combo-box>
                <label for="inputTimeFormat" class="time-format-label">Time Format:</label>
                <res-custom-combo-box [items]="timeFormats" [allItems]="timeFormats" class="time-format-item"
                    [onSelectionChanged]="onSelectedTimeChanged" [selectedItem]="selectedTimeFormat"
                    [automationId]="modalAutomationId+'-time-format'" [onInputFocusLost]="onFocusChanged"></res-custom-combo-box>
                <div *ngIf="isDateTimeOneField" class="delimiter-item">
                    <label>Delimiter:</label>
                    <res-custom-combo-box [items]="concatDelimiters" [allItems]="concatDelimiters"
                        [onSelectionChanged]="onDelimiterChanged" [onInputFocusLost]="onFocusChanged"
                        [automationId]="modalAutomationId+'-date-time-one-field-delimiter'" required
                        [selectedItem]="selectedDelimiter" inputWidth="48"></res-custom-combo-box>
                </div>
            </div>
        </div>

        <div class="fields-container" [ngClass]="fieldsSelectAreaClass" *ngIf="!getModalTypeByKeyName('date')">
            <div class="section-heading">Load File Field</div>
            <select class="fields-selector" [(ngModel)]="selectedField" name="selectedField"
                [attr.data-automation-id]="modalAutomationId + '-load-file-field-first-row-option'">
                <option *ngFor="let field of fieldList" [value]="field.externalName">{{field.externalName}}</option>
            </select>
            <div *ngIf="getModalTypeByKeyName('text') && selectedTextOperation === 'Concatenate'">
                <select class="fields-selector" [(ngModel)]="selectedConcatField" required name="selectedConcatField"
                    [attr.data-automation-id]="modalAutomationId + '-load-file-field-second-row-option'">
                    <option *ngFor="let field of fieldList" [value]="field.externalName">{{field.externalName}}</option>
                </select>
            </div>
        </div>

        <div *ngIf="getModalTypeByKeyName('date')">
            <div class="date-headings">
                <div class="section-heading load-heading">Load File Field</div>
                <div class="section-heading contains-heading">Field Contains</div>
            </div>

            <div class="date-fields-container">
                <select class="fields-selector" [(ngModel)]="selectedDateField" name="selectedDateField" required
                    [attr.data-automation-id]="modalAutomationId + '-date-fields-dropdown'">
                    <option *ngFor="let field of dateFieldList" [value]="field.externalName">{{field.externalName}}
                    </option>
                </select>
                <div *ngIf="isDateTimeOneField">Date and Time</div>
                <div class="date-time-container" *ngIf="!isDateTimeOneField">
                    <div class="radio">
                        <input type="radio" id="date1" name=dateField1 [(ngModel)]="isDateFirst" [value]="true"
                            (ngModelChange)="isDateFirstChanged()"
                            [attr.data-automation-id]="modalAutomationId + '-date-first-radio-button'">
                        <label for="date1">
                            Date
                        </label>
                    </div>
                    <div class="radio">
                        <input type="radio" id="time1" name=timeField1 [(ngModel)]="isTimeFirst" [value]="true"
                            (ngModelChange)="isTimeFirstChanged()"
                            [attr.data-automation-id]="modalAutomationId + '-time-first-radio-button'">
                        <label for="time1">Time</label>
                    </div>
                </div>
                <select *ngIf="!isDateTimeOneField" class="fields-selector" [(ngModel)]="selectedField" required
                    name="selectedTimeField" [attr.data-automation-id]="modalAutomationId + '-time-fields-dropdown'">
                    <option *ngFor="let field of fieldList" [value]="field.externalName">{{field.externalName}}</option>
                </select>
                <div class="date-time-container" *ngIf="!isDateTimeOneField">
                    <div class="radio">
                        <input type="radio" id="date2" name=dateField2 [(ngModel)]="isDateFirst"
                            (ngModelChange)="isDateFirstChanged()" [value]="false"
                            [attr.data-automation-id]="modalAutomationId + '-date-second-radio-button'">
                        <label for="date2">Date</label>
                    </div>
                    <div class="radio">
                        <input type="radio" id="time2" name=timeField2 [(ngModel)]="isTimeFirst"
                            (ngModelChange)="isTimeFirstChanged()" [value]="false"
                            [attr.data-automation-id]="modalAutomationId + '-time-second-radio-button'">
                        <label for="time2">Time</label>
                    </div>
                </div>
            </div>
        </div>
    </form>
</res-base-modal>